export var hexToRgba = function hexToRgba(hex, opacity) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? "rgba(" + [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)].join() + "," + opacity + ")" : null;
};
export var mixColors = function mixColors(firstColor, secondColor, weight) {
  if (weight === void 0) {
    weight = 50;
  }
  var decimalToHex = function decimalToHex(d) {
    return d.toString(16);
  }; // convert a decimal value to hex
  var hexToDecimal = function hexToDecimal(h) {
    return parseInt(h, 16);
  }; // convert a hex value to decimal

  var color = '#';
  var color1 = firstColor.replace('#', '');
  var color2 = secondColor.replace('#', '');
  for (var i = 0; i <= 5; i += 2) {
    // loop through each of the 3 hex pairs—red, green, and blue
    var v1 = hexToDecimal(color1.substr(i, 2)); // extract the current pairs
    var v2 = hexToDecimal(color2.substr(i, 2));

    // combine the current pairs from each source color, according to the specified weight
    var val = decimalToHex(Math.floor(v2 + (v1 - v2) * (weight / 100.0)));
    while (val.length < 2) {
      val = "0" + val;
    } // prepend a '0' if val results in a single digit

    color += val; // concatenate val to our new color string
  }

  return color;
};